import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./Logo.module.css";
import clsx from "clsx";
export const Logo = ({ onClick, layoutClassName, variant = "header" }) => {
    return (_jsx("div", { className: clsx(styles.container, styles[variant], [
            onClick && styles.clickable,
            layoutClassName && layoutClassName,
        ]), onClick }));
};
